<template lang="pug">
.integrations-block
  .center
    .integration-header
      .header-image
        img(v-if="hasImage" :src="image")
      h3 {{ integration.LocalizedName }}
    .integration-body
      .subline.type-small {{ integration.LocalizedDescription }}
      .subline.type-small {{ developmentState }}
      .subline.type-small Categories: {{ categories }}
    .integration-footer
      .status
        div(v-if="integration.Status === 'Active'")
          span(class="integrations-icon")
            BriqIcon(name="icon-input-checkbox-icon")
          span.enabled Enabled
        div(v-else-if="integration.LegacyMode === 'On'")
          span.legacy LEGACY MODE
        div(v-else) Disabled
      .detail-button
        BriqButton(@click="$emit('edit')" variant="main" wide :disabled="!integration.Available") Details
</template>

<script>
import { pipe, map, prop, join } from 'ramda'

export default {
  props: {
    integration: {
      type: Object,
      required: true,
    },
  },
  computed: {
    image() {
      return `data:${this.integration.LocalizedImageMimeType};base64,${this.integration.LocalizedImage}`
    },
    hasImage() {
      return !!this.integration.LocalizedImage
    },
    developmentState() {
      switch (this.integration.DevelopmentState) {
        case 'InDevelopment':
          return 'In Development'
        case 'Alpha':
          return 'Alpha'
        case 'Beta':
          return 'Beta'
        case 'NoLongerSupported':
          return 'No Longer Supported'
      }
      return ''
    },
    categories() {
      const stringify = pipe(map(prop('LocalizedName')), join(', '))
      return this.integration.Categories?.length ? stringify(this.integration.Categories) : 'none'
    },
  },
}
</script>

<style scoped lang="stylus">
.integrations-icon
  color #3e9e00

.enabled
  font-weight bold
  padding-left 5px

.legacy
  background #f5e895
  padding .25em
  font-weight 500

.detail-button
  vertical-align bottom

.status
  margin-bottom 15px
  padding 8px
  border-top 1px solid #c1c1c1
  border-bottom 1px solid #c1c1c1

.integration-body
  height 100px

.integrations-block
  display inline-block
  margin-bottom 1em
  width 248px
  height 338px
  margin 0px 20px 0 0

h3
  display block
  align-items center
  margin-right 0.4em
  line-height 1.4
  height 35px
  overflow hidden

.center
  width 100%
  background #FFF
  border 1px solid #c1c1c1
  text-align center
  padding 10px

.subline
  height 40px
  color rgba(52, 58, 64, 0.35)

.header-image
  height 70px

img
  max-height 50px
  max-width 200px
</style>
